module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-section"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "map-section__panel"
  }, [_c('h6', {
    staticClass: "map-section__panel__heading"
  }, [_vm._v("\n      Tax treaty status\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled map-section__panel__pills row"
  }, _vm._l((_vm.statuses), function(name) {
    return _c('li', {
      staticClass: "list-unstyled-item map-section__panel__pills__item col-sm-6 col-md-12"
    }, [_c('i', {
      staticClass: "fa fa-circle mr-2",
      style: ({
        color: _vm.color(name)
      })
    }), _vm._v(" " + _vm._s(name) + "\n      ")])
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-map', {
    ref: "map",
    staticClass: "map-section__leaflet",
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "options": _vm.options
    }
  }, [_c('v-geojson', {
    ref: "geojson",
    attrs: {
      "geojson": _vm.geojson.content,
      "options": _vm.geojson.options
    }
  }), _vm._v(" "), _c('v-marker', {
    attrs: {
      "lat-lng": _vm.marker.latlng,
      "icon": _vm.marker.icon
    }
  }, [_c('v-popup', {
    attrs: {
      "content": _vm.marker.popup
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "map-section__leaflet__source"
  }, [_vm._v("\n      Source: Mauritius Revenue Authority, PwC, PKF International |\n      Interactive published: November 7, 2017 |\n      Map: "), _c('a', {
    attrs: {
      "href": "http://leafletjs.com",
      "title": "A JS library for interactive maps"
    }
  }, [_vm._v("Leaflet")])])], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p-3 bg-light m-0"
  }, [_c('strong', [_vm._v("Welcome to Mauritius: Africa’s offshore tax hub.")]), _vm._v("\n      Where one country has a tax treaty with Mauritius that includes lower\n      tax rates for Mauritian companies, that treaty can help companies save\n      millions in tax and move money out of Africa.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597a3196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapSection.vue
// module id = 772
// module chunks = 1